<div id="loader" *ngIf="isVisible">
    <img src="assets/img/loader/ay-loader.gif" class="img-loader" alt="AgYield Logo" /><br />
    <span class="loading-text">Loading...</span>
</div>
